import { Component } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { isUndefined, removeSpace, toBoolean } from 'src/app/services/codeUtils';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { Platform } from '@ionic/angular';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { DeviceDetailsCollectorService } from 'src/app/services/kount/kount.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { DeeplinkRedirectService } from 'src/app/services/deeplink-redirect/deeplink-redirect.service';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
	selector: 'app-init',
})

export class AppInitComponent {

	private initTriggeredBy;
	private _Que = [];
	public depositCode = '';
	public optInId = null;
	public initTime = 0;
	public customer;
	public accountBalances: any;
	public customerQualification: any;
	public geolocationPasses: boolean;
	public loading;
	public appInitNextEvent: Subscription;
	public boydSubscription: Subscription;
	public wlAgreed: boolean;
	public reconfirmPersonalDetails: boolean;

	constructor(
		private eventsService: EventsService,
		private userSessionService: UserSessionService,
		private accountBalanceService: AccountBalanceService,
		private navigator: Navigator,
		private configService: ConfigService,
		private lobbyNavigator: LobbyNavigator,
		private lobbyService: LobbyService,
		private gameHubControllerService: GameHubControllerService,
		private cashierContentService: CashierContentService,
		private utilsService: UtilsService,
		private jurisdiction: JurisdictionService,
		private boydRewardsService: BoydRewardsService,
		private responsibleGamingProvider: ResponsibleGamingService,
		private platform: Platform,
		private commonAlertService: CommonAlertService,
		private keywordService: KeywordsService,
		private kountService: DeviceDetailsCollectorService,
		private logoutService: LogoutService,
		private withdrawService: WithdrawalService,
		private deeplinkRedirectService: DeeplinkRedirectService,
		private loginService: LoginService
	) {
		this.eventsService.subscribe('event:appInit:init', (params) => {
			this.initTriggeredBy = !!params && !!params.triggeredBy ? params.triggeredBy : '';
			this.depositCode = !!params && !!params.depositCode ? params.depositCode : '';
			if (!this.initTime) {
				this.initTime++;
				setTimeout(() => this.init(), 60);
			}
		});

		this.eventsService.subscribe("event:authentication:logout", () => {
			this.navigator.dismissAll();
			this.eventsService.unsubscribe("event:appInit:next");
			if (!!this.boydSubscription) this.boydSubscription.unsubscribe();
			this.initTime = 0;
			this._Que = [];
		})

		if (this.platform.is("capacitor")) {
			this.mobileSetup();
		}
	}

	private mobileSetup() {
		if (this.platform.is("android")) {
			this.platform.backButton.subscribeWithPriority(100, () => {
				this.navigator.goBackOrExitApp();
			});
		}
		
		setTimeout(() => {
			this.deeplinkRedirectService.deeplinksListener();	
		}, 2000);
	}

	init() {
		forkJoin([
			this.userSessionService.getCustomer().pipe(take(1)),
			this.accountBalanceService.getBalance().pipe(take(2)),
			this.accountBalanceService.callGetQualification('freespin').pipe(take(1)),
		]).subscribe(([customer, balance, customerQualification]) => {
			this.customer = customer;
			this.accountBalances = balance;
			this.customerQualification = customerQualification;
			this.setTheRulesAndStart();
			this.geolocationPasses = false;
		});

		this.appInitNextEvent = this.eventsService.subscribe('event:appInit:next', (data) => {
			if (!isUndefined(data) && data && !isUndefined(data.geolocationPasses)) {
				this.geolocationPasses = data.geolocationPasses;
			}
			this.popQueAndNext("event:appInit:next")
		}
		);

		this.accountBalanceService.updateBalance();
		this.withdrawService.callGetPayoutMethods();
	}

	protected setTheRulesAndStart(): any {
		const rules = this.rules();



		if (rules.customerCoolingOff()) this.addCoolOffAction();
		if (rules.migratedPlayer()) this.addMigration();
		if (rules.customerIncomplete()) this.addSignupStepTwo();
		if (rules.customerKYCFail()) this.addKYCInvalid();
		if (rules.customerLoginEligiblityCheck()) this.askForEligibility();

		if (this.initTriggeredBy == "REFRESH") {
			if (rules.customerMFA() == 'true') this.addMFA();
			if (rules.customerStrongAuthRequiredCheck() == 'true') this.addStrongAuthentication();
		}

		if (rules.hasCurrentTab()) this.addCurrentTabAction();

		if (this.initTriggeredBy !== 'REFRESH' || location.hash == '#launchDS') {
			if (location.hash == '#launchDS') {
				this.utilsService.removeUrlParams();
			}
		}

		const geoAfterLoginFlag: boolean = toBoolean(this.configService.getConfig().FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN) ?? true; // by default it will be true
		const geoAfterRefreshFlag: boolean = toBoolean(this.configService.getConfig().FEATURE_GEOLOCATION_ENFORCED_ON_REFRESH) ?? true; // by default it will be True

		this.showLobby();

		// Add Boyd enroll Popup on Login.
		if (!rules.customerNotActive() && this.initTriggeredBy !== 'REFRESH') {

			this.checkPendingLimit();

			if (this.configService.getConfig().FEATURE_KOUNT_COLLECT_DATA === '1') {
				this.addKountDataCollectCall();
			}


			if (this.configService.getConfig().FEATURE_SHOW_LIMITS_ON_LOGIN === '1') this.addCheckPendingLimit();
			if (this.configService.getConfig().FEATURE_SHOW_WIN_LOSS_ON_LOGIN === '1') this.addWinLossPopup();
			// Add GeoComply Verification on Login.
			if (geoAfterLoginFlag && !rules.customerNotActive()) {
				this.addGeoComplyVerification();
			}
			const isRewardPopupQueued: boolean = !this.navigator.checkModalDuplication('EnrollBoydRewardsComponent')
			const isRewardPopupEnabled: boolean = toBoolean(this.configService.getConfig().FEATURE_SHOW_BOYD_REWARDS_ON_LOGIN);
			const rewardWorkFlow: boolean = isRewardPopupEnabled && isRewardPopupQueued;
			const hideBoydRewards: boolean = this.configService.getConfig().BOYD_REWARDS_HIDE === '1';
			if (rewardWorkFlow && !hideBoydRewards) this.addBoydRewardEnroll();
		}


		// Check Geo Location on Refresh with config check
		if (geoAfterRefreshFlag && !rules.customerNotActive() && this.initTriggeredBy === 'REFRESH') {
			this.addGeoComplyVerification();
		}
		if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
			if (rules.customerAnnualReconfirmationCheck()) {
				this.addPersonalReconfirmation();
			}
		}

		this.addLobbyCheckForNotificationLoop();
		if (rules.registrationLoginWithADepositCode()) this.addRedirectToDepositPage();
		if (rules.waitingToLaunchAGame()) this.addLaunchGame();
		if (rules.waitingToOpenModal()) this.openModalWindow();
		if (rules.registrationLoginWithAnOffer()) this.optInToOffer();

		this.addNotifications();
		// this.addOfflineNotifications();


		//Limit Confirmation
		// if (this.initTriggeredBy !== "REFRESH" && rules.customerIsActive()) {

		//   }

		this._Que.reverse();
		this.next();
	}

	addKountDataCollectCall() {
		this._Que.push({
			name: "Kount Data Collection",
			action: () => {
				try {
					this.kountService.onDoCollectionClick();
					this.popQueAndNext("Boyd Enroll Verification");
				} catch (e) {
					console.log(e);
					this.popQueAndNext("Boyd Enroll Verification");
				}

			}
		})
	}

	addStrongAuthentication() {
		this._Que.push({
			name: "Strong Auth",
			action: () => {
				this.navigator.navigateTo("PinLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this._Que.pop(); this.next() } })
			}
		})
	}


	rules() {

		let isQualified = () => {
			let data = this.customerQualification.payload;
			let pageToNavigate;

			let response: any = {
				result: true,
				pageToNavigate: pageToNavigate,
			};

			if (!!data) {
				switch (data['policy-name']) {
					case 'emailvalidation':
						pageToNavigate = 'InvalidEmailComponent';
						break;
					case 'geolocation':
						pageToNavigate = 'InvalidGeoComponent';
						break;
					case 'kyc':
						pageToNavigate = 'InvalidKycComponent';
						break;
					case 'spincriteria':
						pageToNavigate = 'InvalidSpinPage';
						break;
					case 'geocomply':
						pageToNavigate = 'GeoComplyComponent';
						break;
				}
				response = {
					result: false,
					pageToNavigate: pageToNavigate,
				};
			}
			return response;
		};

		let customerIsActive = () => {
			return (this.customer.status.toLowerCase() === "active") ? true : false;
		}

		let customerNotActive = () => {
			return this.customer.status.toLowerCase() === 'active' ? false : true;
		};

		let customerIncomplete = () => {
			return this.customer.status.toLowerCase() === 'incomplete' ? true : false;
		};

		let customerKYCFail = () => {
			return this.customer.status.toLowerCase() === 'kyc_fail' ? true : false;
		};

		let customerCoolingOff = () => {
			return ('status' in this.customer && this.customer.status == 'SELF_EXCLUDED_COOL_OFF');
		};

		let customerMFA = () => {
			let mfa = localStorage.getItem('userSession.mfa');
			return mfa;
		}

		let customerStrongAuthRequiredCheck = () => {
			return localStorage.getItem('strongAuthenticationRequired');
		}
		let migratedPlayer = () => {
			const incompletePlayer: boolean = customerIncomplete();
			return !!this.customer && incompletePlayer && (this.customer.getCustomDataProperty('CRE_BY') === 'MIGRATION' || this.customer.getCustomDataProperty('CRE_BY') === 'PA_MIGRATION');
		}

		// if MFREESPIN > 0 && is not a new customer
		let hasDailySlot = () => {
			let availableSpins = 'undefined' !== typeof this.accountBalances.MFREESPIN ? this.accountBalances.MFREESPIN.availableBalance : false;
			let customerData: Array<any> = !!this.customer ? this.customer.customData : [];
			let newAccountValue = customerData.filter((x) => { return x.key === 'NEW_ACCOUNT_TASKS'; }).map((x) => x.value).reduce((value) => value, 0);
			let isNewCustomer = <string>newAccountValue === '1' ? true : false;
			let slotEnabled = this.configService.getConfig().SITE_HAS_DAILY_SLOT === '1' ? true : false;
			return availableSpins && !isNewCustomer && slotEnabled ? availableSpins : false;
		};

		let hasValidEmail = () => {
			return !!this.customer && !isUndefined(this.customer.emailValidated) && this.customer.emailValidated ? true : false;
		};

		let registrationLoginWithADepositCode = () => {
			return !!this.depositCode ? true : false;
		};

		let hasCurrentTab = () => {
			return this.lobbyNavigator.getCurrentTab() !== (null || undefined) ? true : false;
		}

		let waitingToLaunchAGame = () => {
			return this.lobbyService.getWaitingGameData() !== null ? true : false;
		};

		let waitingToOpenModal = () => {
			return this.lobbyService.getWaitingDialogPage() !== null ? true : false;
		};

		let shouldLoadGeocomply = () => {
			let hash = document.location.hash.split('&').shift();
			let hashes = [
				'#show-page',
				'#paypal',
				'#paypal-funded',
				'#paypad-nonfunded',
				'#password_reset',
				'#interac-return'
			];
			return !(hash && hash !== '' && hashes.indexOf(hash) > -1);
		};

		let isSportsApp = () => {
			return this.configService.isSportsApp();
		};

		let registrationLoginWithAnOffer = () => {
			return !!this.optInId ? true : false;
		};

		let customerAnnualReconfirmationCheck = () => {
			if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
				this.reconfirmPersonalDetails = localStorage.getItem("reconfirmPersonalDetails") !== null;
			}
			return this.reconfirmPersonalDetails;
		}

		let customerLoginEligiblityCheck = () => {
			return this.loginService.checkForEligibility()
		};

		return {
			customerCoolingOff,
			customerIncomplete,
			customerKYCFail,
			customerMFA,
			customerNotActive,
			customerIsActive,
			hasCurrentTab,
			hasDailySlot,
			hasValidEmail,
			isQualified,
			isSportsApp,
			migratedPlayer,
			registrationLoginWithADepositCode,
			customerStrongAuthRequiredCheck,
			registrationLoginWithAnOffer,
			shouldLoadGeocomply,
			waitingToLaunchAGame,
			waitingToOpenModal,
			customerLoginEligiblityCheck,
			customerAnnualReconfirmationCheck,
		};
	}


	addCoolOffAction() {
		this._Que.push({
			name: 'Customer Cool Off',
			action: () => {
				this.navigator.navigateTo('CoolingOffComponent', { forceModal: true });
			},
		});
	}

	addCurrentTabAction() {
		this._Que.push({
			name: 'Current Tab Action',
			action: () => {
				const currentTab = this.lobbyNavigator.getCurrentTab();
				switch (currentTab) {
					case 'livedealer':
						let gameData = this.lobbyService.getWaitingGameData();
						//LD lobby with casino game from log out case
						if (!!gameData) {
							if (this.checkIfLiveGame(gameData)) {
								return this.liveGameWorkflow(gameData);
							}

						}
						this.lobbyNavigator.toKeyTab(this.lobbyService.getLiveDealerKeywordName() ? this.lobbyService.getLiveDealerKeywordName() : 'Live dealer');
						//this.lobbyNavigator.toKeyTab('Live dealer');
						break;
				}
				this.lobbyNavigator.setCurrentTab(null);
			},
		});
	}

	addSignupStepTwo() {
		this._Que.push({
			name: 'Signup step 2',
			action: () => {
				this.navigator.navigateTo('SignupStepTwoComponent', { forceModal: true });
			},
		});
	}

	addMigration() {
		this._Que.push({
			name: "Customer Migration Check",
			action: () => {
				const playerMigrationPageEnabled: boolean = this.configService.getConfig().FEATURE_PLAYER_MIGRATION_WP_ENABLED ?? true;
				playerMigrationPageEnabled ?
					this.navigator.navigateTo("PlayerMigrationComponent", { forceModal: true }) :
					this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true });
			}
		})
	}

	addKYCInvalid() {
		this._Que.push({
			name: 'Invalid Kyc',
			action: () => {

				let kyc_step = this.customer.getCustomDataProperty('KYC_STEP');
				if (this.customer.getCustomDataProperty('IS_PEP_OR_HIO') === 'true') {
					this.commonAlertService.showPepHioAlert(undefined, this.closeModal());
					// check config if we go to CAMS Idology
				} else if (!isUndefined(this.configService.getConfig().FEATURE_IS_IDOLOGY)) {
					//canada - we don't set governmentTypeId
					switch (kyc_step.toUpperCase()) {
						case 'PENDING_RETRY':
							this.navigator.navigateTo("CamsComponent");
							break;
						case 'PENDING_IDSCAN':
							this.navigator.navigateTo("CamsComponent");
							break;
						case "DONE":
							setTimeout(() => { this._Que.pop(); this.next() }, 500);
							break;
						default:
							this.navigator.navigateTo("CamsComponent");
							break;
					}
				} else if (isUndefined(this.customer.kyc_attempts)) {
					this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
				} else {
					let attempts = this.configService.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
					if (this.customer.kyc_attempts < attempts) {
						this.navigator.navigateTo('InvalidKycComponent');
					} else if (this.customer.kyc_attempts >= attempts) {
						this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
					}
				}
			},
		});
	}

	askForEligibility() {
		this._Que.push(({
			name: "Face ID eligibility",
			action: () => {
				this.loginService.showEligibility();
			}
		}))
	}

	closeModal = () => {
		this.navigator.dismissAll();
		this.logoutService.onLogout({ reason: 'QUALIFICATION_KYC_FAIL' });
	};

	addMFA = () => {
		this._Que.push({
			name: "MFA",
			action: () => {
				let isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ? this.configService.getConfig().FEATURE_MFA_TYPE : 'SMS';

				if (isSMS_OR_EMAIL == 'SMS') return this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("SmsLoginComponent") } })

				return this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("CodeLoginPage") } })
			}
		})
	}

	showLobby() {
		this._Que.push({
			name: "Show Lobby",
			action: () => {
				this.eventsService.publish("event:lobby:show");
				this.popQueAndNext("Boyd Enroll Verification")
			}
		})
	}

	addBoydRewardEnroll = () => {
		this._Que.push({
			name: 'Boyd Enroll Verification',
			action: () => {
				this.boydSubscription = this.boydRewardsService.checkConnectionToBoydCard().pipe(take(1)).subscribe(res => {
					if (!res) {
						this.navigator.navigateTo('EnrollBoydRewardsComponent', { forceModal: true }, { callBackFn: () => { this.popQueAndNext("EnrollBoydRewardsComponent") } });
					} else {
						this.popQueAndNext("EnrollBoydRewardsComponent else")
					}
				}, err => {
					this.popQueAndNext("EnrollBoydRewardsComponent error")
					console.log(err);
				});

			},
		});
	}


	addCheckPendingLimit = () => {
		// this.boydSubscription.unsubscribe();
		this._Que.push({
			name: 'Check Pending Limit Verification',
			action: () => {
				this.responsibleGamingProvider.getAllPendingLimit().subscribe(
					(response: any) => {
						if (response && !!response.result && !!response.payload) {
							if (response.payload.length !== 0) {
								this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true }, { callBackFn: () => { this.popQueAndNext("LimitConfirmationComponent callbk") } });
							} else {
								this.popQueAndNext("LimitConfirmationComponent else")
								console.log('No Pending Limit for User')
							}
						}
					},
					(error) => {
						this.popQueAndNext("LimitConfirmationComponent else")
						//console.log(error);
					}
				);
			},
		});

	}

	addWinLossPopup = () => {

		this._Que.push({
			name: 'Win Loss Popup',
			action: () => {
				let data = {
					title: "Win/Loss",
					message: "You may check your wins/losses for the current session or for previous sessions.",
					linkText: "Go to my wins/losses report.",
					confirmLink: () => {
						this.wlAgreed = true;
						// this._Que.pop(); this.next();
					},
					decline: () => {
						// this._Que.pop(); this.next();
					}
				};

				let wlPpopupPromise = this.navigator.openPopover(
					"PopoverStandardConfirmComponent",
					{ message: data }, "standard-popover",
					true, true, true, -1, 'cover', true
				);
				wlPpopupPromise.then(p => {
					p.onDidDismiss().then(() => {
						this.popQueAndNext("Win Loss Popup")
					})
				})
			},
		});
	}



	addGeoComplyVerification = () => {
		this._Que.push({
			name: 'GeoComply Verification',
			action: () => {
				this.jurisdiction
					.debounceVerifyJurisdiction(() => { })
					.then((geoResp: GeoResponse) => {
						if (this.wlAgreed) {
							this.goToWinLoss();
						}
						this.popQueAndNext("GeoComply Verification")
					})
					.catch((err) => {
						this.popQueAndNext("GeoComply Error")
					});

			},
		});

	}

	goToWinLoss = () => {
		this.navigator.navigateTo("WinLossComponent", { forceModal: true }, { callBackFn: () => { this.popQueAndNext("WinLossComponent") } });
	}



	addLobbyCheckForNotificationLoop() {
		this._Que.push({
			name: 'Notification listener on lobby',
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish('event:lobby:checkMarketingNotification');
				setTimeout(() => {
					this.popQueAndNext("Notification listener on lobby")
				}, 3000);
			},
		});
	}

	checkPendingLimit() {
		this._Que.push({
			name: "User has Pending Limit Confirmation to check",
			action: () => {

				this.responsibleGamingProvider.getAllPendingLimit().subscribe(
					(response: any) => {
						if (response && !!response.result && !!response.payload) {
							if (response.payload.length !== 0) {
								this.navigator.navigateTo('LimitConfirmationPage', { forceModal: true });
							} else {
								console.warn('No Pending Limit for User');
							}

						}
					},
					(error) => {
						console.error(error);
					}
				);
				setTimeout(
					() => {
						this._Que.pop(); this.next();
					}
				);
			}
		})
	}

	addRedirectToDepositPage() {
		this._Que.push({
			name: 'Navigate to Deposit page with code.',
			action: () => {
				this.navigator.navigateTo('DepositMainComponent', { forceModal: true }, { depositCode: this.depositCode });
			},
		});
	}

	addPersonalReconfirmation() {
		this._Que.push({
			name: 'Annual Personal Reconfirmation',
			action: () => {
				this.navigator.openPopover('PopoverReconfirmation', {}, 'standard-popover reconfirm', false, true, true, -1, 'cover', true);

			},
		});
	}

	addLaunchGame() {
		this._Que.push({
			name: 'Launch a game',
			action: () => {
				let gameData = this.lobbyService.getWaitingGameData();
				if (!!gameData) {
					if (this.checkIfLiveGame(gameData)) {
						return this.liveGameWorkflow(gameData);
					}
					this.gameHubControllerService.launchCasinoGame(gameData);
				}
			},
		});
	}

	private checkIfLiveGame = (gameData: any): Boolean => gameData.super_type == 'LIVE_DEALER' ? true : false;

	private liveGameWorkflow(gameData: any): any {
		setTimeout(() => {
			this.keywordService.getLiveDealerKeywordInfo().subscribe(res => {
				if (res) {
					return this.lobbyNavigator.selectKeyword(res);
				}
			}).unsubscribe();
		}, 300);

		return this.lobbyNavigator.liveDealerBonusPopover(gameData);
	}

	addTestPopup() {
		this._Que.push({
			name: 'Add test pop',
			action: () => {
				this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true }, { status: false });
			},
		});
	}

	addNotifications() {
		this._Que.push({
			name: "Notification Listener",
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish("event:notifications:start");
			}
		})
	}

	openModalWindow() {
		this._Que.push({
			name: 'Open Modal Window',
			action: () => {
				const dialogPage = this.lobbyService.getWaitingDialogPage();
				const dialogPageParams = this.lobbyService.getWaitingDialogPageParams();
				if (dialogPage?.slice(0, 5) == 'CCNP_') return this.onContentPlaceholder(dialogPage);
				this.lobbyService.clearWaitingDialogPage();
				this.lobbyService.clearWaitingDialogPageParams();
				if (!!dialogPage && dialogPage == 'LoginComponent') return;
				if (!!dialogPage && !!dialogPageParams && dialogPage == 'DepositMainComponent') {
					if (dialogPageParams && dialogPageParams.depositcode) {
						this.cashierContentService.updateBonusOfferValue(dialogPageParams.depositcode);
					}
					return this.navigator.navigateTo(dialogPage, { multipleModals: true }, dialogPageParams);
				}
				if (!!dialogPage) return this.navigator.navigateTo(dialogPage);
			},
		});
	}

	optInToOffer() {
		this._Que.push({
			name: 'Opt-In to offer.',
			action: () => {
				let link = this.configService.getExternalLinks().payload.find((link) => link.code == this.optInId);
				this.eventsService.publish('event:webview:load', link.url);
			},
		});
	}

	private onContentPlaceholder(pageName?: string) {
		const link: string = pageName?.replace("CCNP_", "");
		const cleanedLink = removeSpace(link);
		return this.navigator.navigateTo('ContentPlaceholderComponent', { multipleModals: true }, { link: cleanedLink });
	}

	next() {
		this.userSessionService.isAuthenticated().then((isAuthenticated) => {
			if (!isAuthenticated) return;

			if (this._Que.length) {
				let next = this._Que[this._Que.length - 1];
				if (!isUndefined(next) && 'action' in next) {
					console.log("AppInit: ", next.name);
					next.action();
				}
			} else {
				this.onFinish();
			}
		});
	}

	onFinish() {
		if (this.loading) this.loading.dismiss();
		this.appInitNextEvent.unsubscribe();
		//this.navigator.dismissAll();
	}

	popQueAndNext(name) {
		let action = (!!name ? name : "no name")
		console.log("App Init call next: ", name)
		this._Que.pop();
		this.next();
	}

}
